import { getAllSettingsApi, UpdateSettingsApi } from "../settings/settings";

const readSettings = async () => {
  const response = await getAllSettingsApi();
  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to load settings (status ${response.status})`);
  }
  return response.data;
};

const writeSettings = async (settings) => {
  const response = await UpdateSettingsApi(settings);
  if (response.status !== 200) {
    throw new Error(`Failed to update settings (status ${response.status})`);
  }
  return response.data || {};
};

export const getHolidayDaysSimpleApi = async () => {
  const data = await readSettings();
  return {
    success: true,
    holidayPricingDays: Array.isArray(data.holidayPricingDays)
      ? data.holidayPricingDays
      : [],
  };
};

export const addHolidayDaySimpleApi = async (date) => {
  const currentSettings = await readSettings();
  const currentHolidays = Array.isArray(currentSettings.holidayPricingDays)
    ? currentSettings.holidayPricingDays
    : [];

  if (currentHolidays.includes(date)) {
    return {
      success: false,
      error: "Date already exists in holiday list",
      holidayPricingDays: currentHolidays,
    };
  }

  const updatedHolidays = [...currentHolidays, date];
  const updatedSettings = {
    ...currentSettings,
    holidayPricingDays: updatedHolidays,
  };

  const saved = await writeSettings(updatedSettings);

  return {
    success: true,
    message: "Holiday day added successfully",
    holidayPricingDays: Array.isArray(saved.holidayPricingDays)
      ? saved.holidayPricingDays
      : updatedHolidays,
  };
};

export const removeHolidayDaySimpleApi = async (date) => {
  const currentSettings = await readSettings();
  const currentHolidays = Array.isArray(currentSettings.holidayPricingDays)
    ? currentSettings.holidayPricingDays
    : [];

  if (!currentHolidays.includes(date)) {
    return {
      success: false,
      error: "Date not found in holiday list",
      holidayPricingDays: currentHolidays,
    };
  }

  const updatedHolidays = currentHolidays.filter((d) => d !== date);
  const updatedSettings = {
    ...currentSettings,
    holidayPricingDays: updatedHolidays,
  };

  const saved = await writeSettings(updatedSettings);

  return {
    success: true,
    message: "Holiday day removed successfully",
    holidayPricingDays: Array.isArray(saved.holidayPricingDays)
      ? saved.holidayPricingDays
      : updatedHolidays,
  };
};
